module.exports = __webpack_public_path__ + "img/sabongfight.35d58f83.png";